import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DJAreaSideMenu from './sidemenu';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';

export default class DJAreaMembers extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			search: '',
			users: {},
			rank: [],
		};
		this.handleChange = this.handleChange.bind(this);
		this.searchUsers = this.searchUsers.bind(this);

		this.handleChange1 = this.handleChange1.bind(this);
		this.handleFilter = this.handleFilter.bind(this);
  };

  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});
		this.searchUsers();
	}

	componentWillUnmount() {
		clearTimeout(this.timeout);
	}

	handleChange(event) {
		//var isChecked = event.target.checked;
		clearTimeout(this.timeout);
		var item = event.target.value;
		if( event.target.name === "search" ) this.setState({search: item});
		let rank = this.state.rank;
		if( event.target.name!=='search') {
			if(event.target.checked) {
				rank.push(event.target.value);
			} else {
				let index = rank.indexOf(event.target.value)
				rank.splice(index,1);
			}
		}
		this.setState({rank});
		this.timeout = setTimeout(() => {this.searchUsers()}, 2000);
	}
	handleChange1(event) {
		event.preventDefault();
		clearTimeout(this.timeout);
		this.searchUsers();
	}

	handleFilter(filter) {
		this.setState({filter},()=>{this.searchUsers()});
	}


	searchUsers = async(e) => {
		try{
		e.preventDefault();
		} catch(error) {}
		this.setState( { users: '' } );
		clearTimeout(this.timeout);
		let params = new URLSearchParams();
		//params.append( 'Date', Date() );
		//params.append( 'msg', 'Hi there!' );
		params.append('search', this.state.search);
		params.append('rank', this.state.rank.length>0?this.state.rank.join(','):'');
		const x = await postApi('/api/v2/djarea/members', params);
		this.setState({users: x.data.Users});
	}
	

	render() {
		const users = 
      Object.keys(this.state.users).map((e,i) => {
        return (
          <div key={i} className="col-lg-6">
						<div className="p-schedule-event">
							<div className="row">
								<div className="p-schedule-event-image">
									<img src={`https://mix365.co.uk${this.state.users[e].avatar}`} width="90" height="90" alt="profile avatar" />
								</div>
								<div className="col-4">
									<div className="p-schedule-event-dj"><br />
										<Link to={`/${this.state.users[e].username.toLowerCase().replaceAll(' ','_')}`}>{this.state.users[e].title ?
											<>
												{this.state.users[e].title}&nbsp;<small>({this.state.users[e].username})</small>
											</>
										:
											<>{this.state.users[e].username}</>
										}
										</Link><br />
										{this.state.users[e].level}
									</div>
								</div>
								<div className="col"><br />
									{this.state.users[e].country.length>0&&<FontAwesomeIcon icon="location-dot" />} {this.state.users[e].country.replaceAll('/',' / ')}<br />
									{this.state.users[e].timezone.length>0&&<FontAwesomeIcon icon={['far', 'clock']} />} {this.state.users[e].timezone}
								</div>
							</div>
						</div>
					</div>
        )
      })
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				<Col>
					<Row>
						<Col xs md={2}>
							<Form className="pagelayer-contact-form" id="contact-form" onSubmit={(e)=>this.handleChange1(e)}>
								<div className="pagelayer-contact-holder">
									<InputGroup className="p-aav3421 pagelayer-contact_item" style={{paddingBottom: '0px'}}>
										<FormControl type="text" name="search" id="search" onChange={(e)=>this.handleChange(e)}  placeholder="Search Members" aria-label="Name" aria-describedby="basic-addon1" required style={{padding: '5px 10px'}} />
									</InputGroup>
									<div className="previousset-content">
										<label htmlFor={`Owner`} style={{fontWeight: 200}}>Owner</label>
										<div className="float-right">
											<input type="checkbox" name="Owner" id="Owner" value="32" onChange={(e)=>this.handleChange(e)} />
										</div>
									</div>
									<div className="previousset-content">
										<label htmlFor={`Admin`} style={{fontWeight: 200}}>Admin</label>
										<div className="float-right">
											<input type="checkbox" name="Admin" id="Admin" value="31" onChange={(e)=>this.handleChange(e)} />
										</div>
									</div>
									<div className="previousset-content">
										<label htmlFor={`Junior Admin`} style={{fontWeight: 200}}>Junior Admin</label>
										<div className="float-right">
											<input type="checkbox" name="Junior Admin" id="Junior Admin" value="30" onChange={(e)=>this.handleChange(e)} />
										</div>
									</div>
									<div className="previousset-content">
										<label htmlFor={`Clubbers DJ`} style={{fontWeight: 200}}>Clubbers DJ</label>
										<div className="float-right">
											<input type="checkbox" name="Clubbers DJ" id="Clubbers DJ" value="21" onChange={(e)=>this.handleChange(e)} />
										</div>
									</div>
									<div className="previousset-content">
										<label htmlFor={`Radio DJ`} style={{fontWeight: 200}}>Radio DJ</label>
										<div className="float-right">
											<input type="checkbox" name="Radio DJ" id="Radio DJ" value="20" onChange={(e)=>this.handleChange(e)} />
										</div>
									</div>
									{/*<div className="previousset-content">
										<label htmlFor={`Subscriber`} style={{fontWeight: 200}}>Subscriber</label>
										<div className="float-right">
											<input type="checkbox" name="Subscriber" id="Subscriber" onChange={(e)=>this.handleChange(e)} />
										</div>
									</div>*/}
									<div className="previousset-content">
										<label htmlFor={`Member`} style={{fontWeight: 200}}>Member</label>
										<div className="float-right">
											<input type="checkbox" name="Member" id="Member" value="10" onChange={(e)=>this.handleChange(e)} />
										</div>
									</div>
									<div className="previousset-content">
										<label htmlFor={`Pending`} style={{fontWeight: 200}}>Pending</label>
										<div className="float-right">
											<input type="checkbox" name="Pending" id="Pending" value="2" onChange={(e)=>this.handleChange(e)} />
										</div>
									</div>
									<div className="previousset-content">
										<label htmlFor={`Guest`} style={{fontWeight: 200}}>Banned</label>
										<div className="float-right">
											<input type="checkbox" name="Guest" id="Guest" value="1" onChange={(e)=>this.handleChange(e)} />
										</div>
									</div>
								</div>
							</Form>
						</Col>
						<Col>
							<Row>
								{users}
							</Row>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}
}
